<template>
  <div class="space-y-6">
    <h1 class="text-xl font-bold">Log In</h1>
    <form action="#" method="post" @submit="onSubmit" class="space-y-4">
      <dh-input name="username" v-model="username" label="Email" />
      <dh-input name="password" v-model="password" label="Password" type="password" />
      <dh-button>Log in</dh-button>
    </form>
  </div>
</template>

<script lang="ts">
import {defineComponent, inject, ref} from "vue";
import { useRouter } from "vue-router";
import DhInput from "@/components/DhInput.vue";
import { auth } from "@/api";
import DhButton from "@/components/DhButton.vue";
import eventemitter from "eventemitter3";

export default defineComponent({
  name: "Login",
  components: {
    DhButton,
    DhInput,
  },
  setup() {
    const router = useRouter();
    const username = ref("");
    const password = ref("");
    const emitter = inject("eventemitter") as eventemitter;

    return {
      username,
      password,
      async onSubmit(event: MouseEvent) {
        event.preventDefault();
        try {
          const response = await auth.token({ username, password });
          localStorage.token = response.data.token;
          router.push({ name: "home" });
          emitter.emit("tenant:update");
        } catch (error) {
          alert(error.message);
        }
      },
    };
  },
});
</script>
